import { render, staticRenderFns } from "./PaymentPurpose.vue?vue&type=template&id=66cb0bef"
import script from "./PaymentPurpose.vue?vue&type=script&lang=js"
export * from "./PaymentPurpose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports